import { ScheduleAdapter } from '~/services/adapters/schedule.adapter';
import { TDayOfWeek } from '~/types/app.types';
import { ISessionConfig } from '~/types/server.types';

export class ScheduleService extends ScheduleAdapter {
    dayOfWeekToIndex = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6
    };

    indexToDayOfWeek: Record<number, TDayOfWeek> = {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday'
    };

    generateNewSessionConfig() {
        let newSessionDefaults: ISessionConfig = {
            _id: '-1',
            session_name: '',
            session_color: 'purple',
            enabled: true,
            session_description: '',
            session_timezone: null,
            session_type: null,
            meeting_location: '',
            phone_call_caller: 'me',
            phone_call_number: '',
            video_meeting_link: '',
            session_duration: {
                unit_type: 'minutes',
                unit_count: 30
            },
            buffer_before: null,
            buffer_after: null,
            notice_period: null,
            window_type: 'indefinitely',
            fixed_start_date: '',
            fixed_end_date: '',
            confirmation_message:
                'Thank you for scheduling a session with me!\n\nPlease view the details of this session below:',
            allow_rescheduling: true,
            allow_canceling: true,
            send_confirmation_email: true,
            schedule_behaviour_type: '',
            day_availabilities: [],
            shared_member_ids: [],
            session_reminders: [
                {
                    reminder_type: 'email',
                    when: { unit_count: 1, unit_type: 'hours' }
                },
                {
                    reminder_type: 'email',
                    when: { unit_count: 1, unit_type: 'days' }
                }
            ],
            session_url: null,
            shared_members: null,
            placement_id: null,
            updated_at: null,
            set_as_project_date: false
        };

        // generate default availabilities
        Object.values(this.indexToDayOfWeek).forEach(dayOfWeek => {
            newSessionDefaults.day_availabilities.push({
                time_ranges: ['Sunday', 'Saturday'].includes(dayOfWeek)
                    ? []
                    : [
                          {
                              range_time_start: '9:00',
                              range_time_end: '17:00'
                          }
                      ],
                day_of_week: dayOfWeek,
                override_date: ''
            });
        });

        return newSessionDefaults as ISessionConfig;
    }
}
